import { css } from 'lit';

export const tutorialViewStyles = css`

  view-content {
    padding-top: 6rem;
  }

  h1 {
    font-size: 1.7rem;
    line-height: 1.3em;
    margin: 0;
  }
  .info {
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    color: var(--green-7);
    font-size: 1.1rem;
  }

  sl-button[variant='text']::part(base) {
    color: var(--gray-6);
    padding-left: 0;
    font-weight: 200;
  }

  zero-md {
    border-radius: 12px;
    box-shadow: var(--sl-shadow-small);
    margin: 0 -1rem;
  }
  @media(min-width: 650px) {
    zero-md {
      margin: 0;
    }
  }

`;
